module.exports = __webpack_public_path__ + "img/pt_manage.210c8962.svg";